<h2 mat-dialog-title>Add alias</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Alias domain"
      formControlName="domain"
      type="text"
      [errorMessages]="errors['domain']"
    ></app-input-field>

    <mat-checkbox formControlName="emailService">With own email service</mat-checkbox>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Add Alias</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
